import { render, staticRenderFns } from "./DetailBasicForm.vue?vue&type=template&id=505c85c9&scoped=true&"
import script from "./DetailBasicForm.vue?vue&type=script&lang=ts&"
export * from "./DetailBasicForm.vue?vue&type=script&lang=ts&"
import style0 from "./DetailBasicForm.vue?vue&type=style&index=0&id=505c85c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505c85c9",
  null
  
)

export default component.exports